import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { graphql } from '@apollo/react-hoc';
import { toGlobalId } from 'graphql-relay';
import { Link } from 'react-router';
import { SimpleLoadingComponent } from '../../utils/apollo';
import PageTitle from '../../components/PageTitle';
import CreateUser from '../../components/CreateUser';
import Icon from '../../components/Icon';
import updateHEAccount from '../../mutations/HEAccount/updateHEAccount';

const initialLockStatus = {
  locked: false,
  invalidAttempts: [],
};

export class CreateUserPageComponent extends React.PureComponent {
  static propTypes = {
    location: PropTypes.shape({
      state: PropTypes.shape({
        linkBack: PropTypes.object,
      }),
    }),
    viewer: PropTypes.object,
    updateHEAccountMutation: PropTypes.func.isRequired,
    router: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    currentViewer: PropTypes.object.isRequired,
  };

  state = {
    createError: {},
  };

  getLinkBack() {
    return get(this.props, 'location.state.linkBack', null);
  }

  navigateToCaller() {
    const link = '/settings/manageUsers';
    const path = this.getLinkBack() || link;
    this.props.router.push(path);
  }

  _handleCancel = () => {
    this.navigateToCaller();
  };

  _handleSave = ({ firstName, lastName, email, role }) => {
    const { updateHEAccountMutation, currentViewer: { idToken } } = this.props;
    const id = toGlobalId('HEAccount', idToken['custom:institution']);
    const onFailure = (error) => {
      const state = {
        requesting: false,
      };
      if (!error) {
        state.createError = { generalError: true };
      } else if (error.message.includes('already exists')) {
        state.createError = { userExists: true };
      } else {
        state.createError = { generalError: true };
      }
      this.setState(state);
    };

    const onSuccess = () => {
      this.navigateToCaller();
    };

    this.setState({ requesting: true, createError: {} });
    return updateHEAccountMutation({
      variables: {
        input: {
          heAccount: {
            id,
            heUser: {
              firstName,
              lastName,
              email,
              role,
              active: true,
              lockStatus: JSON.stringify(initialLockStatus),
            },
          },
        },
      },
    }).then(onSuccess).catch(onFailure);
  };

  render() {
    const { createError, requesting } = this.state;
    const { viewer } = this.props;
    const linkBack = this.getLinkBack();
    return (
      <div>
        <PageTitle title="User" category="Settings" />
        {
          linkBack &&
          (<Link to={linkBack}><Icon name="angle left" />Back</Link>)
        }
        <CreateUser
          onCancel={this._handleCancel}
          onSave={this._handleSave}
          requesting={requesting}
          createError={createError}
          viewer={viewer}
        />
      </div>
    );
  }
}

const query = gql`
  query CreateUserPageComponent {
    viewer {
      id
      heAccount {
        id
        freemium
        activeSubscriptions
      }
    }
  }
`;

const graphqlData = graphql(query);
const updateHEAccountMutation = graphql(updateHEAccount, { name: 'updateHEAccountMutation' });

const mapStateToProps = (state) => ({
  currentViewer: get(state, 'current.viewer'),
});
const CreateUserPageReduxContainer = connect(mapStateToProps, {})(CreateUserPageComponent);
export default SimpleLoadingComponent(graphqlData, updateHEAccountMutation)(CreateUserPageReduxContainer);
